import React, { useState } from 'react';
import { Phone, Mail } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { LegalModal } from './LegalModal';
export function Footer() {
  const {
    t
  } = useLanguage();
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  return <>
      <footer className="bg-brand-blue text-white pt-16 pb-8 border-t-4 border-brand-red" data-id="element-36">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-37">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-38">
            {/* Brand Col */}
            <div className="flex flex-col items-center md:items-start" data-id="element-39">
              <div className="bg-white p-2 rounded-lg mb-6 inline-block" data-id="element-40">
                <img src="https://cdn.magicpatterns.com/uploads/bxk2iYynfEy5p9ph9KhBBP/CLPAINTING.png" alt="C&L Painting Logo" className="h-16 w-auto object-contain" data-id="element-41" />
              </div>
              <p className="text-blue-100 font-medium text-center md:text-left max-w-xs mb-4" data-id="element-42">
                {t.footer.title}
              </p>
              <div className="mt-2" data-id="element-43">
                <p className="text-amber-300 font-heading font-bold text-xs tracking-widest uppercase mb-2" data-id="element-44">
                  {t.footer.ownersLabel}
                </p>
                <p className="text-white font-medium" data-id="element-45">{t.footer.owner1}</p>
              </div>
            </div>

            {/* Contact Col */}
            <div className="flex flex-col items-center md:items-start" data-id="element-46">
              <h3 className="text-xl font-heading font-bold mb-6 text-white" data-id="element-47">
                {t.footer.contactHeader}
              </h3>
              <a href="tel:8324397965" className="flex items-center gap-3 text-2xl font-bold text-brand-red hover:text-red-400 transition-colors mb-4" data-id="element-48">
                <Phone className="w-6 h-6" data-id="element-49" />
                (832) 439-7965
              </a>
              <a href="mailto:clpaintingremodeling@gmail.com" className="flex items-center gap-3 text-lg font-medium text-blue-100 hover:text-white transition-colors mb-4" data-id="element-50">
                <Mail className="w-5 h-5" data-id="element-51" />
                {t.footer.email}
              </a>
            </div>

            {/* Service Areas Col */}
            <div className="flex flex-col items-center md:items-start" data-id="element-52">
              <h3 className="text-xl font-heading font-bold mb-6 text-white" data-id="element-53">
                {t.footer.areaHeader}
              </h3>
              <p className="text-blue-100 text-center md:text-left" data-id="element-54">
                {t.footer.areaDesc}
              </p>
            </div>
          </div>

          <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-55">
            <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8" data-id="element-56">
              <p className="text-blue-200 text-sm text-center md:text-left" data-id="element-57">
                {t.footer.copyright}
              </p>
              <div className="flex gap-4 text-sm" data-id="element-58">
                <button onClick={() => setIsTermsOpen(true)} className="text-blue-200 hover:text-white transition-colors underline-offset-4 hover:underline" data-id="element-59">
                  {t.footer.terms}
                </button>
                <span className="text-blue-400" data-id="element-60">•</span>
                <button onClick={() => setIsPrivacyOpen(true)} className="text-blue-200 hover:text-white transition-colors underline-offset-4 hover:underline" data-id="element-61">
                  {t.footer.privacy}
                </button>
              </div>
            </div>

            <div className="flex flex-col items-center md:items-end gap-2" data-id="element-62">
              <div className="text-blue-200 text-sm font-medium px-3 py-1 bg-white/10 rounded-full" data-id="element-63">
                Licensed & Insured
              </div>
              <a href="https://www.thedoctorecommerce.com" target="_blank" rel="noopener noreferrer" className="text-xs text-blue-400/60 hover:text-blue-300 transition-colors tracking-wide" data-id="element-64">
                {t.footer.builtBy}
              </a>
            </div>
          </div>
        </div>
      </footer>

      <LegalModal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} title={t.legal.terms.title} content={t.legal.terms.content} data-id="element-65" />

      <LegalModal isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} title={t.legal.privacy.title} content={t.legal.privacy.content} data-id="element-66" />
    </>;
}